import thinkingdata from "thinkingdata-browser";

import Client from "@/assets/scripts/client.js";
import Request from '@/utils/request.js';

import { getTraceStore } from '@/utils/storage.js';
import { decryptCode } from '@/utils/common.js';
import { pk } from '@/config/common.js';
import { isRelease } from '@/config/base.js';

try {
  if (isRelease && Client.env.isApp) {
    Request({
      url: '/api/v2/comm/aws/key?type=1',
      method: 'get'
    }).then(resData => {
      let jsonObj = JSON.parse(decryptCode(resData, pk))
      if (jsonObj && jsonObj.appId && jsonObj.url) {
        window.ta = thinkingdata
        window.ta.init({
          appId: jsonObj.appId || '',
          serverUrl: jsonObj.url || '',
          // 缓存>批量发送
          batch: false,
          autoTrack: {
            pageShow: false,
            pageHide: false,
          },
          // mode: "debug"
        })

        const uid = Client.getUserBaseInfo().uid

        ta.login(uid || '');
        window.ta.setSuperProperties({ channel: Client.getAppInfo().channel || '' })

        if (uid && window.ta) {
          const sotreTraceArr = getTraceStore(`thinkingdata_${uid}`)
          if (Array.isArray(sotreTraceArr)) {
            // 清理缓存
            window.localStorage.removeItem(`thinkingdata_${uid}`)
            // 上报数数
            sotreTraceArr.forEach(item => {
              window.ta.track('h5_page_track', item)
            })
          }
        }
      }
    })
  }
} catch (err) {
  console.log('try catch', err)
}